import {Component, ChangeDetectorRef} from '@angular/core';

import {EditDataService} from "../services/edit-data.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})

export class FooterComponent  {
private data:any = {};
  constructor(public editDataService: EditDataService) {

  }

  ngOnInit() {
    this.editDataService.getData().subscribe(data => this.data = data);
  }
}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/footer/footer.component.ts